import React from 'react';

const Tags = ({ tagTitle }) => {
  return (
    <div className="border border-gray-500 text-gray-500 px-2 rounded-full text-xs w-max">
      {tagTitle}
    </div>
  );
};

export default Tags;
